import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { FILTER_DATA_LIST_RESPONSE } from "../types/ResponseTypes";
import { GET_FILTER_CIRCULATING_NURSE_QUERY_KEY, GET_FILTER_QUERY_KEY } from "../types/CommonTypes";

type FilterContextParams = {
  startDate: string;
  endDate: string;
  ots?: string;
  procedureIds?: string;
  attendingSurgeonNames?: string;
};

async function getFilterCurculatingNurseData(params: FilterContextParams): Promise<FILTER_DATA_LIST_RESPONSE> {
  const { data } = await fetcher({
    url: "analytics/filter-options/circulating-nurses",
    params,
  });
  return data?.options || [];
}

export function useGetFilterCurculatingNurseQuery(params: FilterContextParams,enabled: boolean = false) {
  return useQuery({
    queryKey: [GET_FILTER_QUERY_KEY, GET_FILTER_CIRCULATING_NURSE_QUERY_KEY, params],
    queryFn: () => getFilterCurculatingNurseData(params),
    enabled: enabled && !!params, 
    staleTime: 5 * 60 * 1000,
  });
}
